<template>
<div class="bodyeqp">
 <div class="head-right">
                  <button type="button" v-on:click="$emit('back')"  class="btn btn-third btn-sm ml-3"  style="margin-top: 13px; height:30.4px;width:27.4"  v-b-tooltip.hover :title="$lang.Common.Tooltip.ButtonBack"><i class="fas fa-arrow-circle-left"></i></button>
                  <h4 class="head-title-rg" style="margin-top: 15px;margin-left: 7px">Detalhe Supervisão - {{dataEqp.codigoObra}}</h4>
                  <div class="ml-auto d-flex" style="gap: 1rem; justify-content: center; align-items: center; margin-right: 1rem;">
                    <div class="btnNotAprovacao" v-if="dataEqp.statusvistoria != 2" v-on:click="$emit('AdicionarObs')" v-b-tooltip.hover :title="'Reprovar vistoria'"><i class="fa fa-minus-circle" style="color: white; font-size: 15px;"></i></div>
                    <div class="buttonAprovar"  v-if="dataEqp.statusvistoria != 3" v-on:click="$emit('openAprovedVistoria')" v-b-tooltip.hover :title="'Aprovar vistoria'"><img class="mr-1" src="https://static.zopone.com.br/img/survey/IconeSim.svg" ></div>
                  </div>
              </div>
              <div class="mt-3">
  <Tables ref="tableGrid"
              :columns="headTable"
              :showSearch="false"
              :showPrint="false"
              :showDownload="false"
              style="font-family: Segoe UI;"
              :showFullscreen="false"
              v-on:Load="onLoad"
            >
              <tr v-for="obj in dataEquipam" v-bind:key="obj.id">
                <TableColumn :IsText="true" :status="1" :value="obj.epi.descricaoReduzida == null ? 'N/D': obj.epi.descricaoReduzida " />
                <TableColumn :IsText="true" :status="1" :value="obj.ca == null ? 'N/D' : obj.ca" />
                <TableColumn v-on:Edit="onSelect(obj)" :newStateVistoria="true" :colorStatusVistoria="getAplicarColorFundoTable(obj)" :descriptionNewStatusVistoria="getAplicarDescricaoTable(obj)" :fontColorStatusVistoria="getAplicarColorTable(obj)" style="font-weight: bold; font-size: 9px;"></TableColumn>
                <!-- <td :class="getStatus(obj) == true ?  'conforStatus'  : getAplicar(obj) == true ? 'notStatus' : 'notAplica' ">{{getStatus(obj) == true ? 'Conforme' :  getAplicar(obj) == true ?  'Não Conforme' : "Não se aplica"}}</td> -->
                <TableColumn :apllicar="getAplicar(obj)" :IsSurvey="obj.naoSeAplica === false" v-on:Edit="showModal(obj)" :isSurveyButtonOk="getStatus(obj)" v-on:Change="onChange(obj)" v-on:Delete="onDelete(obj)"  />
              </tr>
            </Tables>
            <modalepisurvey ref="modalepi"></modalepisurvey>
            </div>
</div>
</template>
<script>
import eqpsurvey from './eqpSurvey.js'
export default eqpsurvey
</script>

<style>
.btnNotAprovacao{
  margin-top: 0px;
  width: 40px;
  height: 40px;
  cursor: pointer;
  border: none;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #b72121 0% 0% no-repeat padding-box;
  outline: none;
}
.btnNotpdf{
  margin-top: 0px;
  width: 40px;
  height: 40px;
  cursor: pointer;
  border: none;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #c9c9c9 0% 0% no-repeat padding-box;
  outline: none;
}
.buttonAprovar{
  margin-top: 0px;
  cursor: pointer;
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #008148 0% 0% no-repeat padding-box;
  outline: none;
}
.buttonAprovar:hover{
  background: rgb(7, 161, 72);
}
.notStatus{
  background: red;
  text-align: center;
  color: white;
  font-size: 15px;
  border-radius: 2px;
}
.notAplica{
  background: rgb(206, 202, 0);
  text-align: center;
  color: white;
  font-size: 15px;
  border-radius: 2px;
}
.conforStatus{
  widows: 100px;
  text-align: center;
  background: green;
  color: white;
  font-size: 15px;
  border-radius: 2px;
}
.bodyeqp{
  border: 1px solid #CFD8DC;
}
</style>



// WEBPACK FOOTER //
// src/views/private/Survey/components/eqpSurvey/eqpSurvey.vue